import { ROUTES } from 'src/router/const'

// Input maxlength constants for security validation
export const MAX_LENGTH = {
  DOCUMENT: 10000, // For document editors (TinyMCE, assessment documents)
  LONG_TEXT: 5000, // For textareas, notes, long text inputs
  MEDIUM_TEXT: 255, // For names, titles, descriptions, general inputs
  SHORT_TEXT: 40, // For very short inputs (person names, codes, etc.)
}

export const NAV_LINKS = [
  {
    name: ROUTES.HOME,
    path: `/${ROUTES.APP}`,
    label: 'Dashboard',
    icon: 'layout-panel-top',
  },
  {
    name: ROUTES.TICKETS,
    path: `/${ROUTES.TICKETS}`,
    label: 'Product requests',
    icon: 'clipboard-clock',
  },
  {
    name: ROUTES.APPROVALS,
    path: `/${ROUTES.APPROVALS}`,
    label: 'Product approvals',
    icon: 'badge-check',
  },
  {
    name: ROUTES.CONFIRMATIONS,
    path: `/${ROUTES.CONFIRMATIONS}`,
    label: 'Product confirmations',
    icon: 'list-check',
  },
  {
    name: ROUTES.POLICIES,
    path: `/${ROUTES.POLICIES}`,
    label: 'Product policies',
    icon: 'scale',
  },
  {
    name: ROUTES.SETTINGS,
    path: `/${ROUTES.SETTINGS}`,
    label: 'Settings',
    icon: 'settings',
    exact: false,
  },
  {
    name: ROUTES.FAQ,
    path: `/${ROUTES.FAQ}`,
    label: 'Help Center',
    icon: 'help-circle',
    exact: false,
  },
]

/**
 * Error UI: pass one entry into BasicError as `error-config` (404 copy + "Go to …" target).
 * Only treat HTTP 404 as not-found — do not synthesize 404 in pages.
 *
 * Keyed by surface, not by route: overlays (ticket drawer, approval modal) need a
 * different entry than the route that hosts them.
 *
 * Optional: `retryIcon` - Lucide name for the "Try again" button (default: `refresh-cw`).
 */
export const ERROR_CONFIGS = {
  DEFAULT: {
    notFoundTitle: 'Data',
    listRoute: ROUTES.HOME,
    listLabel: 'Go to Dashboard',
  },
  /** Ticket drawer, messages tab, and request-edit flow when a ticket fetch fails. */
  TICKET_REQUEST: {
    notFoundTitle: 'Product request',
    listRoute: ROUTES.TICKETS,
    listLabel: 'Go to product requests',
  },
  APPROVAL_MODAL: {
    notFoundTitle: 'Product approval',
    listRoute: ROUTES.APPROVALS,
    listLabel: 'Go to product approvals',
  },
  FAQ: {
    notFoundTitle: 'Help center page',
    listRoute: ROUTES.FAQ,
    listLabel: 'Go to Help Center',
  },
}

/** Synthetic 404 error object for client-side not-found states (e.g. invalid static route params). */
export const NOT_FOUND_ERROR = Object.freeze({ response: { status: 404 } })

export const PROFILE_STATS = [
  {
    key: 'activeApprovals',
    icon: 'badge-check',
    label: 'Active approvals',
    color: 'positive',
  },
  {
    key: 'deniedRequests',
    icon: 'x-circle',
    label: 'Denied requests',
    color: 'warning',
  },
  {
    key: 'underReview',
    icon: 'clipboard-clock',
    label: 'Under review',
    color: 'cta',
  },
  {
    key: 'totalRequests',
    icon: 'clipboard-list',
    label: 'Total requests',
    color: 'brand',
  },
]

export const FOOTER_LINKS = [
  {
    label: 'Privacy Policy',
    href: 'https://www.armadillex.com/privacy-policy',
  },
  {
    label: 'Terms and Conditions',
    href: 'https://www.armadillex.com/terms-conditions',
  },
  // {
  //   label: 'Contact',
  //   href: 'https://www.armadillex.com/contact',
  // },
]

export const DRAWER_BREAKPOINT_WIDTH = 1300

// Narrowest supported window. Below it, production shows the mobile block screen and the
// walkthrough does not start. AppIndex.vue and the walkthrough both read this value.
export const MOBILE_BLOCK_WIDTH = 780

export const THEME = {
  LIGHT: 'light',
  DARK: 'dark',
}

export const DEFAULT_THEME = THEME.LIGHT

// Cache update action types
export const CACHE_ACTIONS = {
  ADD: 'add',
  UPDATE: 'update',
  REMOVE: 'remove',
}

// DOM event names
export const DOM_EVENTS = {
  STORAGE: 'storage',
  MESSAGE: 'message',
}

// BroadcastChannel: single channel name for all cross-tab events
export const BROADCAST_CHANNEL_NAME = 'aigov-broadcast'

// BroadcastChannel topic names (extend for future events e.g. DATA_INVALIDATE)
export const BROADCAST_TOPICS = {
  LOGOUT: 'logout',
  FCM_DATA: 'fcm-data',
}

export const SETTINGS_TABS = [
  { name: ROUTES.SETTINGS_DETAILS, label: 'User details', icon: 'user-round' },
  { name: ROUTES.SETTINGS_INTEGRATIONS, label: 'Integrations', icon: 'workflow' },
  { name: ROUTES.SETTINGS_NOTIFICATIONS, label: 'Notifications', icon: 'bell' },
]
